module.exports = __webpack_public_path__ + "img/08刘凯松.81c70140.png";